<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Cari Tel</label>
            <input class="form-control" v-mask="phoneMask" type="text" v-model="value.CariPhone" placeholder="Cari Tel" />
        </div>
        <div class="col-12">
            <label class="form-label">Cari E-Posta</label>
            <input class="form-control" type="text" v-model="value.CariEmail" placeholder="Cari E-Posta"/>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    },
    data(){
        return{
            phoneMask:'(###) ### ## ##',
        }
    },
}
</script>

<style>

</style>